// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const getBundlerVersion = () => window.BUNDLER_VERSION;
